<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_ii"></a><a id="page_iii"></a>The Long Baby Boom</h1>
<p class="subtitle"><strong>An Optimistic Vision for a Graying Generation</strong></p>
<p class="author"><span class="small">JEFF GOLDSMITH</span></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1a3f68a4